import { Capacitor } from '@capacitor/core'

// Продажи в iOS-сборке. С 22.10.2026 включены: приложение публикуется от
// PTAH MCHJ с подписанным Paid Apps Agreement, подписки идут через App Store
// (services/iap.js, экраны подписки). До этого действовал вариант B: аккаунт
// без соглашения, торговое в iOS было скрыто целиком — ни тарифов, ни цен, ни
// кнопок, потому что гайдлайн App Store 3.1.1 запрещает и IAP без соглашения,
// и отсылку на оплату на сайте.
//
// Флаг оставлен как аварийный выключатель: сборка с VITE_IOS_SALES_DISABLED=1
// снова прячет всё торговое в iOS, остальные платформы не трогает. Условия по
// нему живут в десятке экранов — не удалять.
export const iosSalesDisabled = Capacitor.getPlatform() === 'ios' && import.meta.env.VITE_IOS_SALES_DISABLED === '1'
